module.exports = __webpack_public_path__ + "static/media/sp39.eeab1df1.JPG";